module.exports = __webpack_public_path__ + "static/media/creative_1.24b93684.svg";